import { CustomLayers } from "ags/names";
import { BigWinThresholds } from "ags/utils/win-magnitude";
import { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import Translations from "slotworks/i18n/translations";
import Point from "slotworks/utils/geom/point";
import { Easing, Interpolation, Tween } from "slotworks/utils/tween";

class BigWinBounceText {

    private bigWinText: PIXI.Text;
    private bigWinContainer: PIXI.Container;
    private bounceTween: Tween;
    private enterTween: Tween;
    private layer: Layers;

    private translationText = new Map<BigWinThresholds, string>([
        [BigWinThresholds.SMALL, "small_win"],
        [BigWinThresholds.BIG, "big_win"],
        [BigWinThresholds.HUGE, "huge_win"]
    ] as any);

    public init() {
        this.layer = Layers.Custom.get(CustomLayers.BIGWIN_TEXT);

        this.bigWinText = this.layer.getText("big_win_label");
        this.bigWinText.visible = false;
        this.moveToContainer(this.bigWinText);
    }

    public bounceText(bigWinLevel: BigWinThresholds) {

        this.layer.moveAbove(Layers.BetBar);

        this.switchOrientation(canvasManager.orientation);

        const textKey = this.translationText.get(bigWinLevel);
        this.bigWinText.text = Translations.get(textKey);
        this.bigWinText.visible = true;
        this.bigWinText.alpha = 1;
        this.bigWinContainer.scale.set(0.1, 0.1);

        this.enterTween = new Tween(this.bigWinContainer.scale);
        const enterTarget = [1.4, 0.9, 1];
        this.enterTween.to({ x: enterTarget, y: enterTarget }, 1000);
        this.enterTween.onComplete(() => {
            this.bounceTween = new Tween(this.bigWinContainer.scale);
            const target = [1, 1.4, 0.9, 1];
            this.bounceTween.to({ x: target, y: target }, 1000);
            this.bounceTween.easing(Easing.Sinusoidal.Out);
            this.bounceTween.repeat(Infinity);
            this.bounceTween.interpolation(Interpolation.CatmullRom);
            this.bounceTween.delay(500);
            this.bounceTween.start();
        });
        this.enterTween.start();
    }

    public switchOrientation(newOrientation: Orientation) {

        const scene = this.layer.getScene("default");
        const isLandscape = newOrientation === Orientation.LANDSCAPE;
        const textConfigs = isLandscape ? scene.landscapeTextConfigs : scene.portraitTextConfigs;
        const bigWinConfig = textConfigs.get("big_win_label");
        this.bigWinContainer.x = bigWinConfig.x + bigWinConfig.width / 2;
        this.bigWinContainer.y = bigWinConfig.y + bigWinConfig.height / 2;

        this.layer.moveAbove(Layers.BetBar);
    }

    public fadeOut() {

        if (this.enterTween) {
            this.enterTween.stop();
        }

        if (this.bounceTween) {
            this.bounceTween.stop();
        }

        const exitTween = new Tween(this.bigWinText);
        exitTween.to({ alpha: 0 }, 300);
        exitTween.start();
    }

    private moveToContainer(displayObject: PIXI.DisplayObject) {

        this.bigWinContainer = new PIXI.Container();
        const position = this.layer.localToGlobal(new Point(displayObject.x, displayObject.y));
        this.bigWinContainer.addChild(displayObject);
        this.bigWinContainer.scale.set(0.5);
        this.bigWinContainer.x = position.x;
        this.bigWinContainer.y = position.y;
        this.layer.add(this.bigWinContainer, true);

        displayObject.x = 0;
        displayObject.y = 0;
        displayObject.pivot.set(0.5, 0.5);
    }
}

export default new BigWinBounceText();
